<template>
  <div id="pdf-progress-overlay" v-if="active" class="pdf-progress-overlay">
    <div class="pdf-progress-popup">
      <div class="pdf-progress-title">Your PDF is in progress</div>
      <div class="pdf-progress-subtitle">You can continue working. Once ready - the file will be automatically downloaded.</div>
      <div class="pdf-progress-text">{{ progressText }}</div>
      <div class="pdf-progress-bar">
        <div class="pdf-progress-fill" :style="{ width: progressPercent + '%' }"></div>
      </div>
      <button class="pdf-progress-close" @click="$emit('close')">Close</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PDFProgressPopup',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    currentStep: {
      type: Number,
      default: 0
    },
    totalSteps: {
      type: Number,
      default: 0
    }
  },
  computed: {
    progressPercent() {
      return Math.round((this.currentStep / this.totalSteps) * 100);
    },
    progressText() {
      return `Step ${this.currentStep} of ${this.totalSteps}`;
    }
  }
}
</script>

<style scoped>
.pdf-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.pdf-progress-popup {
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  text-align: center;
  min-width: 360px;
  max-width: 420px;
}

.pdf-progress-title {
  font-size: 20px;
  font-weight: 900;
  color: #000;
  margin-bottom: 10px;
}

.pdf-progress-subtitle {
  font-size: 14px;
  margin-bottom: 20px;
  color: #222;
}

.pdf-progress-text {
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: bold;
}

.pdf-progress-bar {
  width: 100%;
  height: 10px;
  background-color: #eee;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 20px;
}

.pdf-progress-fill {
  height: 100%;
  background: #69029a;
  transition: width 0.3s ease;
}

.pdf-progress-close {
  padding: 10px 20px;
  background: #69029a;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.pdf-progress-close:hover {
  background: #52017a;
}
</style> 